import { Link } from 'react-router-dom';
import { movies, type Movie } from '@/mocks/movies';
import MovieCard from '@/components/base/MovieCard';

const allMovies = movies;

function getMovieCategoryName(slug: string): string {
  const map: Record<string, string> = {
    dongzuo: '动作片',
    xiju: '喜剧片',
    aiqing: '爱情片',
    kehuan: '科幻片',
    kongbu: '恐怖片',
    xuanyi: '悬疑片',
    zhanzheng: '战争片',
    jilu: '纪录片',
    donghua: '动画片',
  };
  return map[slug] || slug;
}

export default function AllMoviesSection() {
  const byCategory = allMovies.reduce<Record<string, Movie[]>>((acc, movie) => {
    if (!acc[movie.category]) acc[movie.category] = [];
    acc[movie.category].push(movie);
    return acc;
  }, {});

  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="mb-6">
        <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-50">
          全部分类
        </h2>
        <p className="text-xs text-foreground-500 mt-1">探索所有类型的精彩电影</p>
      </div>

      <div className="space-y-10">
        {Object.entries(byCategory).map(([slug, categoryMovies]) => (
          <div key={slug}>
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-base font-semibold text-foreground-100">
                {getMovieCategoryName(slug)}
              </h3>
              <Link
                to={`/category/${slug}`}
                className="text-xs text-primary-500 hover:text-primary-400 transition-colors flex items-center gap-1"
              >
                查看更多
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-4">
              {categoryMovies.slice(0, 6).map((movie) => (
                <MovieCard key={movie.id} movie={movie} />
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}